module.exports = __webpack_public_path__ + "static/unicornmain-09389ba157b49b24aea8d240d7c174f6.png";